import { REACT_APP_API_ENDPOINT } from "../helpers/data";
import { handleResponse, sendGetRequest, sendPostRequest } from "./apiUtilis";

export const getStoreProducts = async (req) => {
  try {
    const response = await sendPostRequest(
      REACT_APP_API_ENDPOINT + "product",
      req
    );
    console.error("Response:", response);
    return handleResponse(response);
  } catch (error) {
    console.error("Error in requestContact:", error);
    throw error; // Re-throw the error after logging it
  }
};

export const getAvailableFilters = async () => {
  try {
    const response = await sendGetRequest(
      REACT_APP_API_ENDPOINT + "product/filters"
    );
    console.error("Response:", response);
    return handleResponse(response);
  } catch (error) {
    console.error("Error in requestContact:", error);
    throw error; // Re-throw the error after logging it
  }
};
